import { bulk as bulkUpdate } from './update';
import { subscribe } from './subscription';

export function request(id, query) {
    return {
        type: 'COMPETITIONS_QUERY_REQUEST',
        query,
        id
    };
}

export function error(id, errors) {
    return {
        type: 'COMPETITIONS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, competitions) {
    return (dispatch) => {
        dispatch(bulkUpdate(competitions));

        dispatch({
            type: 'COMPETITIONS_QUERY_FINISH',
            competitions,
            id
        });
    };
}
